import { render, staticRenderFns } from "./gps_detail.vue?vue&type=template&id=72864d96&scoped=true"
import script from "./gps_detail.vue?vue&type=script&lang=js"
export * from "./gps_detail.vue?vue&type=script&lang=js"
import style0 from "./gps_detail.vue?vue&type=style&index=0&id=72864d96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72864d96",
  null
  
)

export default component.exports